import { render, staticRenderFns } from "./MainInfoUser.vue?vue&type=template&id=5ba1344c"
import script from "./MainInfoUser.vue?vue&type=script&lang=js"
export * from "./MainInfoUser.vue?vue&type=script&lang=js"
import style0 from "./MainInfoUser.vue?vue&type=style&index=0&id=5ba1344c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default,VListItemIcon: require('/app/node_modules/vuetify/lib/components/VList/VListItemIcon.js').default,VListItem: require('/app/node_modules/vuetify/lib/components/VList/VListItem.js').default,VList: require('/app/node_modules/vuetify/lib/components/VList/VList.js').default,VMenu: require('/app/node_modules/vuetify/lib/components/VMenu/VMenu.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VMenu})
